<template>
  <div class="app-container">
    <el-card class="box-card">
      <div class="filter-container">
        <div class="times">
          <Times @getTime="getTime" ref="times"></Times>
          <el-form :model="query" ref="queryForm" :inline="true">
            <el-form-item label="业务信息：">
              <el-input v-model="query.nameOrPho" placeholder="请输入姓名/手机号" clearable size="small" />
            </el-form-item>
          </el-form>
        </div>
        <div class="btns">
          <el-button type="primary" @click="handleQuery" size="mini">搜索</el-button>
          <el-button type="info" @click="handleFilter" plain size="mini">重置</el-button>
        </div>
      </div>
      <div class="nav-container">
        <Navs ref="navs" :navList="navList" @changeNav="changeNav" @exportEv="exportEv" :isExport="true"></Navs>
      </div>
      <div class="data-container mt20">
        <el-table v-loading="listLoading" :data="list" @selection-change="selectionChange" @sort-change="sortChange">
          <!-- <el-table-column label="排名" type="index" align="center" width="60"></el-table-column> -->
          <el-table-column label="业务信息" prop="name" align="center">
            <template slot-scope="{row}">
              <div>
                <span>{{ row.name }}</span><br />
                <span>{{ row.pho }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="身份" prop="levelName" align="center"></el-table-column>
          <el-table-column label="团队成员" prop="teamCount" sortable align="center">
            <template slot-scope="{row}">
              <el-link type="primary" @click="toPage('/count/business/team',row,0,row.teamCount)">{{row.teamCount}}</el-link>
            </template>
          </el-table-column>
          <el-table-column label="团队客户人数" prop="customerCount" sortable align="center">
            <template slot-scope="{row}">
              <el-link type="primary" @click="toPage('/count/business/customer',row,1,row.customerCount)">{{row.customerCount}}</el-link>
            </template>
          </el-table-column>
          <el-table-column label="客户人数" prop="teamCustomerCount" sortable align="center">
            <template slot-scope="{row}">
              <el-link type="primary" @click="toPage('/count/business/customer',row,2,row.teamCustomerCount)">{{row.teamCustomerCount}}</el-link>
            </template>
          </el-table-column>
          <el-table-column label="总业绩" prop="totalMoney" sortable align="center">
            <template slot-scope="{row}">
              <el-link type="primary" @click="toPage('/count/business/achievement',row,1,row.totalMoney)">{{row.totalMoney}}</el-link>
            </template>
          </el-table-column>
          <el-table-column label="团队业绩" prop="teamTotalMoney" sortable align="center"></el-table-column>
          <el-table-column label="客户业绩" prop="customerTotalMoney" sortable align="center"></el-table-column>
          <!-- <el-table-column label="订货量" prop="orderCount" sortable="custom" align="center"></el-table-column> -->
          <!-- <el-table-column label="订货金额" prop="orderPrice" sortable="custom" align="center" width="100">
            <template slot-scope="{row}">
              <span style="display: block;margin-bottom: 2px;">{{ row.orderPrice }}</span>
              <el-button type="primary" size="mini">订货明细</el-button>
            </template>
          </el-table-column> -->
        </el-table>
        <pagination v-show="total>0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize" @pagination="doQueryList" />
      </div>
    </el-card>
  </div>
</template>

<script>
import sysDataconstantApi from '@/api/config/sysDataconstant'
import Pagination from '@/components/Pagination'
import Times from '../components/times.vue'
import Navs from '../components/navs.vue'
import clientListApi from '@/api/client/clientList'
import customerLevelApi from '@/api/sys/customerLevel'
export default {
  components: {
    Pagination,
    Times,
    Navs
  },
  data() {
    return {
      list: [],
      total: 0,
      listLoading: true,
      query: {
        pageNo: 1,
        pageSize: 10,
        teamCountSortSign: -1
        // keyword:'',
        // identity:''
      },
      selectItems: [],
      times: null,
      navList: [
        { name: '全部', id: 0 },
        // {name:'营销总监',id:1},
        // {name:'营销经理',id:2},
        // {name:'大区经理',id:3},
        // {name:'地区经理',id:4},
        // {name:'县区经理',id:5}
      ],
      navIndex: 0
    }
  },
  created() {
    this.today = this.dayjs().format('YYYY-MM-DD');
    this.times = {
      timeStart: `${this.today} 00:00:00`,
      timeEnd: `${this.today} 23:59:59`,
    }
    this.doQueryList({ pageNo: 1 })
    this.getBusinessStanding()
  },
  methods: {
    sortChange({ prop, order }) {
      const sortKeyMap = {
        'teamCount': 'teamCountSortSign',
        'customerCount': 'teamCustomerCountSortSign',
        'teamCustomerCount': 'customerCountSortSign',
        'totalMoney': 'totalMoneySortSign',
        'teamTotalMoney': 'teamTotalMoneySortSign',
        'customerTotalMoney': 'customerTotalMoneySortSign'
      }
      for (var k in sortKeyMap) {
        const sortKey = sortKeyMap[k]
        if (k !== prop) {
          this.query[sortKey] = null
        } else {
          if (order === 'ascending') {
            this.query[sortKey] = 1
          } else if (order === 'descending') {
            this.query[sortKey] = -1
          } else {
            this.query[sortKey] = 0
          }
        }
      }
      this.doQueryList({})
    },
    /**
     * 选择框变化
     */
    selectionChange(val) {
      this.selectItems = val
    },
    // 获取业务员身份
    getBusinessStanding() {
      customerLevelApi.fetchList({
        type: 2
      }).then(({
        data
      }) => {
        this.navList.push(...data)
        console.log('客户身份: ', data);
      })
    },
    /**
     * 获取时间段
     */
    getTime(event) {
      this.times = JSON.parse(event)
      if (!this.times.ifUse) {
        this.doQueryList({ pageNo: 1 })
      }
      // console.log('this.times: ',this.times);
    },
    /**
     * 触发搜索操作
     */
    handleQuery() {
      this.doQueryList({ pageNo: 1 })
    },
    /**
     * 触发重置操作
     */
    handleFilter() {
      this.$refs.times.timeIndex = 0
      this.$refs.times.timeShow = ''
      this.$refs.times.timeStart = ''
      this.$refs.times.timeEnd = ''
      this.query = {
        pageNo: 1,
        pageSize: 10,
        teamCountSortSign: -1
      }
      // this.times = null
      this.doQueryList({ pageNo: 1 })
    },
    /**
     * 触发导航切换
     */
    changeNav(index) {
      console.log('index: ', index);
      this.navIndex = index * 1;
      this.doQueryList({ pageNo: 1 });
    },
    /**
     * 触发导出
     */
    exportEv() {
      this.$router.push("/export/list?code=CustomerDownloadYWPer")
    },
    /**
     * 执行列表查询
     */
    doQueryList({ pageNo, pageSize }) {
      if (pageNo) {
        this.query.pageNo = pageNo
      }
      if (pageSize) {
        this.query.pageSize = pageSize
      }
      // console.log('this.navIndex: ',this.navIndex);
      if (this.navIndex) {
        this.query.levelId = this.navList[this.navIndex].level
      } else {
        delete this.query.levelId
      }
      if (this.times && this.times.timeStart) {
        this.query.startTime = this.times.timeStart
        this.query.endTime = this.times.timeEnd
      }
      this.listLoading = true
      return clientListApi.getYeStatistics(this.query).then(({ data }) => {
        console.log('data: ',data.list);
        this.list = data.list
        this.total = data.total
        this.$forceUpdate()
      }).finally(() => {
        this.listLoading = false
      })
    },
    changeSwitch(row) {
      sysDataconstantApi.setIsEnable({ id: row.id, isEnable: row.isEnable }).then(() => {
        this.$common.showMsg('success', '操作成功')
      })
    },
    /**
     * 页面跳转
     */
    toPage(path, row, type, num) {
      // if(!num) return
      if (type) {
        this.$router.push(`${path}?id=${row.id}&index=${type - 1}`)
      } else {
        this.$router.push(`${path}?id=${row.id}`)
      }
    }
  }
}
</script>
<style scoped lang="scss">
.filter-container {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding-bottom: 0;
  .times {
    display: flex;
    align-items: center;
  }
  .btns {
    margin-bottom: 22px;
  }
}
</style>
